import ncAug2023 from './trahan-north-carolina-august-2023/layer.js'
import texas2025 from './trahan-texas-thanksgiving-2025/layer.js';
import yellowstone2026 from './trahan-yellowstone-2026/layer.js';

const trips = {
    name: "Trips",
    layers: [
        {
            name: "North Carolina 2023-08 with Trahans",
            layer: ncAug2023,
        },
        {
            name: "Texas Thanksgiving 2025 with Trahans",
            layer: texas2025,
        },
        {
            name: "Yellowstone 2026-09 with Trahans",
            layer: yellowstone2026,
        },
    ],
};

export default trips;
